import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { useGoToBulkReviewRequirements } from "../../../../BulkReview/paths";
import { PayeeFilterRequirementStatus } from "../../../../Payees/routes/RoutePayees/filters/types";
import { buildPayeeDetailsPath } from "../../../../Payees/utils";
import { useGoToDashboardPayeeRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayeeRequirementDetails";
import { NotificationTemplate } from "../index";
import { RequirementNotificationContext } from "../types";

export type SignatureClientContext = RequirementNotificationContext;

const GROUP_THRESHOLD = 2;

export const SignatureClient: NotificationTemplate<SignatureClientContext> = {
  renderTitle: props =>
    props.group.length >= GROUP_THRESHOLD
      ? "Multiple e-signatures required"
      : "E-signature required",
  renderBody: (props, history) => {
    const payeeName = props.context.payee.payeeName;
    const documentName = props.context.requirement.requirementName;

    if (props.group.length >= GROUP_THRESHOLD) {
      return "Countersign documents that have been signed by your contractors.";
    }

    return (
      <>
        Countersign <b>{documentName}</b> that have been signed by{" "}
        <WSButton.Link
          size="S"
          onClick={() => {
            history.push(buildPayeeDetailsPath(props.context.payee.payeeId));
          }}
        >
          {payeeName}
        </WSButton.Link>
      </>
    );
  },
  Footer: props => {
    const history = useHistory();
    const documentName = props.context.requirement.requirementName;
    const goToPayeeRequirementDetails =
      useGoToDashboardPayeeRequirementDetails();
    const queryFeatureFlags = useQueryFeatureFlags();
    const goToBulkReviewRequirements = useGoToBulkReviewRequirements();

    if (props.group.length >= GROUP_THRESHOLD) {
      return (
        <WSButton.Link
          size="S"
          rightIcon="chevron-right"
          onClick={() => {
            if (queryFeatureFlags.data?.requirementsBulkReview) {
              goToBulkReviewRequirements({
                filter: {
                  status: PayeeFilterRequirementStatus.AwaitingClientSignature
                }
              });
              return;
            }

            history.push("/member/dashboard/clients-e-signatures");
          }}
        >
          Sign documents
        </WSButton.Link>
      );
    } else {
      return (
        <WSButton.Link
          size="S"
          rightIcon="chevron-right"
          onAsyncClick={async () => {
            goToPayeeRequirementDetails({
              requirementId: props.context.requirement.requirementId,
              payeeId: props.context.payee.payeeId
            });
          }}
        >
          Sign <b>{documentName}</b>
        </WSButton.Link>
      );
    }
  }
};
